










































































































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { Inspection } from '@/domain/Inspection'
import { Classification } from '@/domain/Classification'
import ClassificationsService from '@/service/ClassificationsService'

@Component
export default class InspectionDialogComponent extends Vue {
  classificationsService = ClassificationsService.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: Inspection, default: () => new Inspection(), required: true })
  dto!: Inspection

  @Prop({ default: true })
  isNew!: boolean

  /** バリデーション */
  invalid = false

  classifications: Classification[] = []

  mounted() {
    /* 検査分類 */
    this.classificationsService.findAll()
      .then(x => this.classifications = x)
  }

  /**
   * 初期化
   */
  reset() {
    this.dto = new Inspection()
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

}
